/*
 * @Author: jay
 * @Date: 2021-08-25 09:23:58
 * @LastEditTime: 2021-08-25 09:40:05
 * @Description: 公共底部组件
 */
import React from "react";
import styles from "./style.module.less";

const Footer: React.FC<any> = ({ isShunwan }) => {
  return (
    <>
      {window.isZhuayou ? (
        <div className={styles.footerWrap}>
          <div className="logo-01-shun"></div>
          <div className={styles.infos}>
            <p>
              Copyright © 2023 https://zhuayou.com,All Rights Reserved.
              版权所有：武汉爪游互娱科技有限公司
            </p>
            <p>
              游戏健康公告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当
              适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活
            </p>
            <p>
              <a href="http://beian.miit.gov.cn" target="_blank">
                ICP备案编号： 鄂ICP备16010064号-2
              </a>
            </p>
          </div>
        </div>
      ): window.isJieji ? (
        <>
          <div className={styles.footerWrap}>
            <div className="logo-01-jiejie"></div>
            <div className={styles.infos}>
              <p>
                Copyright © 2023 https://qdwuw.com,All Rights Reserved.
                版权所有：武汉街机网科技有限公司
              </p>
              <p>
                游戏健康公告：抵制不良游戏 拒绝盗版游戏 注意自我保护
                谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活
              </p>
              <p>
                <a href="http://beian.miit.gov.cn" target="_blank">
                  ICP备案编号： 鄂ICP备2022006433号-1
                </a>
              </p>
            </div>
          </div>
        </>
      ) :window.isAf ? (
        <>
          <div className={styles.footerWrap}>
            <div className="logo-01-af"></div>
            <div className={styles.infos}>
              <p>
                Copyright © 2023 https://t.dian5.com,All Rights Reserved.
                版权所有：武汉掌游科技有限公司
              </p>
              <p>
                游戏健康公告：抵制不良游戏 拒绝盗版游戏 注意自我保护
                谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活
              </p>
              <p>
                <a href="http://beian.miit.gov.cn" target="_blank">
                  ICP备案编号： 鄂ICP备14007714号-17
                </a>
              </p>
            </div>
          </div>
        </>
      ): isShunwan ? (
        <div className={styles.footerWrap}>
          <div className="logo-01-shun"></div>
          <div className={styles.infos}>
            <p>Copyright @ 2022 武汉生活范网络科技有限公司</p>
            <p>
              公司地址：
              洪山区野芷湖西路16号创意天地2号办公楼3层5号(创客星孵化器)
            </p>
            <p>
              <a href="http://beian.miit.gov.cn" target="_blank">
                ICP备案编号： 鄂ICP备16014623号-2
              </a>
            </p>
          </div>
        </div>
      )  : (
        <div className={styles.footerWrap}>
          <div className="logo-01"></div>
          <div className={styles.infos}>
            <p>武汉团团互娱科技有限公司 版权所有 ©2020 All Rights Reserved</p>
            <p>
              健康游戏忠告：抵制不良游戏 拒绝盗版游戏 适度游戏益脑 沉迷游戏伤身
              合理安排时间 享受健康生活
            </p>
            <p>
              <a href="http://beian.miit.gov.cn" target="_blank">
                ICP备案：鄂ICP备18000273号-4
              </a>{" "}
              &nbsp;&nbsp;网络文化经营许可证 &nbsp;&nbsp;鄂网文[2018]2998-060号
            </p>
            <p>网络游戏出版物号（ISBN）:ISBN 978-7-498-07492-8</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
